var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0997 2.6999L15.4997 7.49995C15.6997 7.89995 16.0997 8.0999 16.4997 8.1999L21.7997 8.99995C22.8997 9.19995 23.2997 10.4999 22.4997 11.1999L18.6997 14.8C18.3997 15.1 18.1997 15.5 18.2997 16L19.1997 21.0999C19.3997 22.1999 18.2997 23 17.3997 22.5L12.4997 20C12.0997 19.8 11.6997 19.8 11.2997 20L6.39967 22.5C5.49967 23 4.39968 22.1999 4.59968 21.0999L5.49967 16C5.59967 15.6 5.39968 15.1 5.09968 14.8L1.29968 11.1999C0.499676 10.4999 0.899673 9.09995 1.99967 8.99995L7.29968 8.1999C7.69968 8.0999 8.09968 7.89995 8.29968 7.49995L10.6997 2.6999C11.2997 1.7999 12.6997 1.7999 13.0997 2.6999Z",
    stroke: "#A35BB1",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon2);
export default __webpack_public_path__ + "static/media/footer_icon2.b0c97901c60a74058570b49fd28c0c1a.svg";
export { ForwardRef as ReactComponent };